'use strict';

var wow = require('wow/dist/wow');

$(window).unload( function() {
    $(window).scrollTop(0);
});

new wow.WOW({
    boxClass : 'wow',
    animateClass : 'animated',
    offset: 150,
    mobile : true,
    live : false
}).init();

$('#mobileSearch').on('click', function() {
    var $this = $(this);

    if($('#contentSearch').is(':visible')) {
        $this.removeClass('open').addClass('closed');
    } else {
        $this.removeClass('closed').addClass('open');
    }

    $('#contentSearch').slideToggle();
});
